import groupBy from 'lodash/groupBy';
import uniqBy from 'lodash/uniqBy';

import type { Capacity } from '~/consts/capacities';

import type { AppliedFlashRoomRate } from '../types';

export const DEFAULT_CAPACITY_COMBINATIONS: Array<Capacity> = [{ adults: 2, children: 0, infants: 0, teenagers: 0 }];

export type CapacityRoomRate = Pick<AppliedFlashRoomRate, 'ratePlanName' | 'roomName' | 'roomRateId' | 'roomTypeId'>;

export type CapacityRoomTypeGroup = {
  ratePlanNames: Array<string>;
  roomName: string;
  roomRates: Array<CapacityRoomRate>;
  roomTypeId: string;
};

export function getDistinctAppliedRoomRates(
  appliedFlashRoomRates: Array<AppliedFlashRoomRate>,
): Array<CapacityRoomRate> {
  return uniqBy(appliedFlashRoomRates, 'roomRateId');
}

// Capacity (max occupancy) is a room-type-level fact in practice, even though the API writes it
// per room rate -- group so "default to 2A" can be applied once across every rate plan a room type sells.
export function groupRoomRatesByRoomType(roomRates: Array<CapacityRoomRate>): Array<CapacityRoomTypeGroup> {
  const roomRatesByRoomTypeId = groupBy(roomRates, 'roomTypeId');

  return Object.values(roomRatesByRoomTypeId).map((roomRatesForType) => ({
    ratePlanNames: uniqBy(
      roomRatesForType.filter((roomRate) => roomRate.ratePlanName),
      'ratePlanName',
    ).map((roomRate) => roomRate.ratePlanName),
    roomName: roomRatesForType[0].roomName,
    roomRates: roomRatesForType,
    roomTypeId: roomRatesForType[0].roomTypeId,
  }));
}
